import { ChevronLeft, Home } from 'react-feather'
import { useHistory } from 'react-router-dom'
import { Title } from '../BasicQuery.styles'
import { Header, Inline } from './Header.styles'

interface Params{
  title: string
}

export const BasicQueriesHeader = ({ title }: Params) => {
  const history = useHistory()
  const goHome = () => history.push('/basic-queries')

  return (
    <Header>
      <Inline onClick={history.goBack}>
        <ChevronLeft/>
        <Title variant='h6'>
          {title}
        </Title>
      </Inline>
      <Home onClick={goHome} cursor='pointer'/>
    </Header>
  )
}
